import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function SplashScreen() {
  const [show, setShow] = useState(() => {
    try { return !sessionStorage.getItem("ac_splash_shown"); } catch { return true; }
  });

  useEffect(() => {
    if (!show) return;
    try { sessionStorage.setItem("ac_splash_shown", "1"); } catch {}
    const t = setTimeout(() => setShow(false), 2000);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-screen"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#09090B]"
          style={{ pointerEvents: "none" }}
        >
          <motion.img
            src="/logo-mark.png"
            alt="Affiliated Connections"
            initial={{ scale: 0.4, rotate: -35, opacity: 0 }}
            animate={{
              scale: [0.4, 1.08, 1],
              rotate: [-35, 0, 0],
              opacity: 1,
              filter: [
                "drop-shadow(0 0 6px rgba(255,0,127,0.3))",
                "drop-shadow(0 0 22px rgba(255,0,127,0.65)) drop-shadow(0 0 26px rgba(0,255,255,0.55))",
                "drop-shadow(0 0 14px rgba(255,0,127,0.5)) drop-shadow(0 0 18px rgba(0,255,255,0.4))",
              ],
            }}
            transition={{ duration: 1.0, ease: "easeOut", delay: 0.05 }}
            className="w-24 h-24 rounded-2xl"
          />
          <motion.div
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            className="mt-5 font-display font-black text-2xl sm:text-3xl tracking-tighter uppercase"
          >
            <span className="text-[#FF007F]">Affiliated</span>
            <span className="text-[#00FFFF]">Connections</span>
          </motion.div>
          <div className="mt-6 h-[3px] w-40 overflow-hidden rounded-full bg-white/10">
            <motion.div
              initial={{ x: "-110%" }}
              animate={{ x: "230%" }}
              transition={{ delay: 0.7, duration: 1.15, ease: "easeInOut" }}
              className="h-full w-1/2 rounded-full"
              style={{ background: "linear-gradient(90deg,#FF007F,#00FFFF)" }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
